



























































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Tab, Tabs, Overlay } from "vant";
import flight from "./modules/flightCard.vue";
import train from "./modules/trainCard.vue";
import taxi from "./modules/taxiCard.vue";
import btripServcice from "@/service/btripServcice";
import _ from "lodash";
import UserService from "@/service/UserService";
import { CalcBenchmark, categoryMap, Categorys, LowestRule, ServiceSecne, ServiceType, ZoneType } from "@/model/Base";
import enumUtils from "@/utils/enumUtils";
import baseService from "@/service/baseService";
@Component({
  name: "traffic",
  components: {
    flight,
    train,
    taxi,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Overlay.name]: Overlay,
  },
  filters: {
    mapCateName(CategoryID: number) {
      let category = categoryMap[CategoryID];
      if (category) {
        return category.CategoryName || category.CategoryTitle;
      }
      return CategoryID;
    },
  },
})
export default class Traffic extends Vue {
  activeCode: string = "";

  data = {};
  get paramCode() {
    return this.$route.params.code;
  }
  beforeMount() {
    this.activeCode = this.$route.params.code || "taxi";
  }
  tabChange(event: any) {
    if (event && this.activeCode != event) {
      this.$router.replace(`/mall/traffic/${event}`);
    }
  }
  @Watch("paramCode")
  watchParamCode() {
    if (this.paramCode && this.paramCode != this.activeCode) {
      this.activeCode = this.paramCode;
    }
  }
  beforeCreated(){
    this.checkService();
  }
  mounted() {
    this.getTripRuleData();
    this.getCitys();
    this.checkService();
  }
  get ServeType() {
    return ServiceType.TrafficService;
  }

  isAvailable:boolean = true;

  checkService(){
    UserService.getServiceList().then(response=>{
      if(!response.isSucc||!response.result)
      {
        return;
      }
      let services:any[]=response.result.filter((o :any)=>o.ServiceType==ServiceType.TrafficService&&o.isSubscribe);
      this.isAvailable = services && services.length>0;
    });
  }

  citys: any[] = [];
  getCitys() {
    let data = { ZoneType: ZoneType.City + "", PageSize: 999999 };
    baseService.getZoneList(data).then(res => {
      if (res.isSucc) {
        this.citys = res.result.entities;
      }
    });
  }

  isShowBtripRule = false;
  TripRuleData: any[] = [];
  getTripRuleData() {
    let data: any = { Users: [] };
    btripServcice.getTripRule(data).then((res: any) => {
      if (res.isSucc) {
        this.TripRuleData = res.result;
        this.$emit("OneSelfs", res.result.OneSelf);
        this.getFlowInfo();
      }
    });
  }

  FlowInfoData: any = "";
  getFlowInfo() {
    let __self = this;
    _.forEach((this as any).TripRuleData.Roles, (item: any) => {
      let FlowID = item.FlowID;
      UserService.getFlowInfo(FlowID).then(json => {
        if (!json.isSucc || !json.result) {
          return;
        }
        let FlowInfo: any = json.result;
        _.forEach(FlowInfo.Nodes, (i: any) => {
          let RoleInfo: any = [];
          _.forEach(i.Roles, t => {
            let FlowRole = t;
            let roleinfo = {
              RoleID: FlowRole.RoleID,
            };
            UserService.getRoleInfo(roleinfo).then(role => {
              if (role.isSucc) {
                RoleInfo.push(role.result);
              }
            });
          });
          i.RoleInfo = RoleInfo;
        });
        __self.FlowInfoData = json.result;
      });
    });
  }

  filterRoleInfo(node?: any) {
    let Roles = _.filter(node.Roles, o => o.DutyCode == "executer");
    let Actives: any = [];
    _.forEach(Roles, o =>
      _.forEach(node.RoleInfo, m => {
        if (o.RoleID == m.RoleID) {
          Actives.push(m);
        }
      })
    );
    return Actives;
  }
  matchCateNames(cateIDs?: any) {
    let __self = this;
    if (!cateIDs) {
      return;
    }

    let levels = cateIDs;
    if (typeof cateIDs == "string") {
      levels = cateIDs.split(/\n|,/g);
    }

    let results = [];
    for (let i = 0; i < levels.length; i++) {
      let level = levels[i];
      let category = categoryMap[level];
      if (category) {
        results.push(category.CategoryName || category.CategoryTitle);
      } else {
        results.push(level);
      }
    }
    return results.join(" ");
  }
  parseServiceTime(serviceTime: string) {
    if (!serviceTime) {
      serviceTime = "[]";
    }
    var jsonTimes = JSON.parse(serviceTime);
    for (let i = 0; i < jsonTimes.length; i++) {
      let jsonTime = jsonTimes[i];
      jsonTime.WeekNames = (this.matchCateNames(jsonTime.Weeks) || "").replace(/星期/gi, "周");
    }
    return jsonTimes;
  }
  parseLocation(location: string) {
    if (!location) {
      location = "[]";
    }
    return JSON.parse(location);
  }

  parsePrice(Prices?: any) {
    let __self = this;
    let results = [];

    if (!Prices || Prices.length == 0) {
      return 0;
    }
    return Prices[0].LimitPrice;
  }

  parseBenchmark(benchmark?: number) {
    if (benchmark == LowestRule.FlightLowestPrice) {
      return "车型列表最低价";
    }
    return "无";
  }
  sceneId: number = ServiceSecne.Business;
  changeScene(sceneId: number) {
    this.sceneId = sceneId;
  }

  matchCityNames(cityIds: string) {
    let __self = this;
    if (!cityIds) {
      return;
    }

    let levels = cityIds.split(/\n|,/g);

    let results = [];
    for (let i = 0; i < levels.length; i++) {
      let level = levels[i];
      let city = this.citys.find(o => o.CityID == level);
      if (city) {
        results.push(city.CityName);
      } else {
        results.push(level);
      }
    }
    return results.join(" ");
  }
}
